var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSame(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 2.8C6.02355 2.8 2.8 6.02355 2.8 10C2.8 13.9764 6.02355 17.2 10 17.2C13.9764 17.2 17.2 13.9764 17.2 10C17.2 6.02355 13.9764 2.8 10 2.8ZM1 10C1 5.02943 5.02943 1 10 1C14.9705 1 19 5.02943 19 10C19 14.9705 14.9705 19 10 19C5.02943 19 1 14.9705 1 10ZM6.265 7.57C6.265 6.84927 6.84927 6.265 7.57 6.265C8.29073 6.265 8.875 6.84927 8.875 7.57C8.875 8.29073 8.29073 8.875 7.57 8.875C6.84927 8.875 6.265 8.29073 6.265 7.57ZM11.125 7.57C11.125 6.84922 11.7093 6.265 12.43 6.265C13.1506 6.265 13.735 6.84922 13.735 7.57C13.735 8.29078 13.1506 8.875 12.43 8.875C11.7093 8.875 11.125 8.29078 11.125 7.57ZM5.86 12.43C5.86 11.9329 6.26294 11.53 6.76 11.53H13.24C13.7371 11.53 14.14 11.9329 14.14 12.43C14.14 12.9271 13.7371 13.33 13.24 13.33H6.76C6.26294 13.33 5.86 12.9271 5.86 12.43Z",
    fill: "#9C85F6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSame);
export default __webpack_public_path__ + "static/media/same.3a523b1f4661afe0b71d104981707fc9.svg";
export { ForwardRef as ReactComponent };